export default class AlreadyHandledError {
  constructor(public readonly originalError: any) {
    Error.call(this, "already handled");
  }
}
